import React, { useState } from 'react';
import { getConditionIconUrl, getConditionIconIdentifier } from '../utils/conditionIcons';

export default function ConditionIcon({ condition, size = 32, className = '' }) {
  const [hasError, setHasError] = useState(false);
  
  // Use saved iconUrl if available, otherwise calculate from condition type
  const iconUrl = condition?.iconUrl || getConditionIconUrl(condition);
  const iconIdentifier = getConditionIconIdentifier(condition);
  
  if (hasError || !iconUrl) {
    return (
      <span 
        className={`badge bg-secondary ${className}`}
        style={{ 
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          minWidth: size,
          height: size,
          fontSize: size < 40 ? '10px' : '12px'
        }}
      >
        {iconIdentifier || '-'}
      </span>
    );
  }
  
  return (
    <img
      src={iconUrl}
      alt={iconIdentifier}
      style={{ width: size, height: size, objectFit: 'contain' }}
      className={className}
      onError={() => setHasError(true)}
    />
  );
}
